import React from "react";

export function SectionTitle({ icon, children }) {
  return (
    <div className="flex items-center gap-3 mb-4">
      <div className="text-espiritu-terra">{icon}</div>
      <div className="kicker">{children}</div>
      <div className="flex-1 h-px bg-espiritu-sand-deep" />
    </div>
  );
}

export function Prose({ children }) {
  return (
    <div className="font-raleway text-espiritu-deep/85 text-[15px] leading-[1.75] space-y-4 max-w-prose">
      {children}
    </div>
  );
}

export function Field({ label, children }) {
  return (
    <label className="block">
      <span className="font-raleway text-[10px] uppercase tracking-[0.22em] text-espiritu-deep/60 block mb-1.5">{label}</span>
      {children}
    </label>
  );
}
